export default {
  worldPriceTitle: "Global Cryptocurrency Price Chart",
  description:
    "This chart is not based on Excoino prices and is just for viewing global cryptocurrency price trends."
};
